export const getIsInvalidDayInMonth = (
  month: number,
  day: number,
  year: number
): boolean => {
  if (!month || !day || !year) {
    return true;
  }
  const thirtyDays = [4, 6, 9, 11];
  const maxDaysInFeb =
    (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0 ? 29 : 28;
  return (
    (month === 2 && day > maxDaysInFeb) ||
    (thirtyDays.includes(month) && day > 30)
  );
};
